import { inject, injectable } from "inversify";

import EditViewModel from "@vm/Edit/EditViewModel";
import AllocationForm from "@vm/Form/Allocation";
import AllocationRepository from "@repository/Allocation";
import Allocation, { AllocationEvent } from "@model/Allocation";

import TYPES from "../../inversify.types";
import { action } from "mobx";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class AllocationEditVM extends EditViewModel<Allocation, AllocationRepository> {
  constructor(
    @inject(TYPES.AllocationRepository) repository: AllocationRepository,
    @inject(TYPES.AllocationForm) public allocationFormVM: AllocationForm
  ) {
    super(Allocation, repository);
  }

  setEntity(entity: Allocation) {
    super.setEntity(entity);
    void this.allocationFormVM.setEntity(entity);
  }

  @action.bound
  async performEvent(event: AllocationEvent) {
    if (!this.entity.id) {
      return false;
    }

    this.currentlyFetching = true;
    try {
      const response = await this.repository.performEvent(this.entity.id, event);

      if (response.status) {
        void this.fetchItem(false);
      }

      return response.status;
    } finally {
      this.currentlyFetching = false;
    }
  }
}
